import React from 'react';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import Icon from '@mdi/react';

import {
  Typography,
  Grid,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
} from '@material-ui/core';
import {
  mdiAccountOutline,
  mdiPackageVariant,
  mdiStateMachine,
  mdiCalendar,
  mdiWarehouse,
  mdiCity,
  mdiKey,
  mdiTruck,
  mdiPencilOutline,
  mdiChevronLeft,
} from '@mdi/js';

const useStyles = makeStyles(theme =>
  createStyles({
    headerWidth: {
      '& .MuiCardHeader-avatar': {
        width: '100%',
      },
    },
  })
);

const CourierCards = props => {
  const classes = useStyles();

  return (
    <Card
      style={{
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardHeader
        style={{width: '100%', padding: '16px 20px'}}
        component="div"
        className={classes.headerWidth}
        avatar={
          <Grid
            style={{
              width: '100%',
              display: 'flex',
            }}
          >
            <img
              style={{marginTop: '-5px', marginLeft: '8px'}}
              src={props.iconUrl}
              alt=""
            />
            <div>
              <Typography>{props.name}</Typography>
            </div>
            <div style={{marginRight: 'auto'}}>
              <Typography>
                {props.counts.reduce(
                  (previousValue, currentValue) => previousValue + currentValue,
                  0
                )}{' '}
              </Typography>
            </div>
          </Grid>
        }
      />
      <CardContent>
        <Divider
          style={{
            width: '120%',
            margin: '-8px -16px 8px -16px',
          }}
        />

        <Grid container md={12} style={{marginTop: '16px'}}>
          {props.cardType === '3pl' && (
            <Grid md={12} item>
              <Button
                onClick={name =>
                  props.handleCardClick(
                    'courierRegisteringCount' + props.cardName
                  )
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`در حال ثبت در کوریر | ${props.counts[0]}`}
              </Button>
              <Button
                onClick={name =>
                  props.handleCardClick(
                    'courierRegisterdCount' + props.cardName
                  )
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`ثبت در کوریر   | ${props.counts[1]}`}
              </Button>
              <Button
                onClick={name =>
                  props.handleCardClick(
                    'courierDeliveredCount' + props.cardName
                  )
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`تحویل به کوریر | ${props.counts[2]}`}
              </Button>
              <Button
                onClick={name =>
                  props.handleCardClick(
                    'courierDelivered3plCount' + props.cardName
                  )
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`تحویل به پیک | ${props.counts[3]}`}
              </Button>
              <Button
                onClick={name =>
                  props.handleCardClick(
                    'courierNotDeliverdCount' + props.cardName
                  )
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`تحویل نشده  | ${props.counts[4]}`}
              </Button>
              <Button
                onClick={name =>
                  props.handleCardClick('courierReturnedCount' + props.cardName)
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`بازگردانده شده   | ${props.counts[5]}`}
              </Button>
            </Grid>
          )}
          {props.cardType === 'Bundle' && (
            <Grid md={12} item>
              <Button
                onClick={name => props.handleCardClick('courierBundledCount')}
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`بسته بندی برای راننده | ${props.counts[0]}`}
              </Button>
              <Button
                onClick={name => props.handleCardClick('courierLoadedCount')}
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`تحویل راننده شده     | ${props.counts[1]}`}
              </Button>
              <Button
                onClick={name =>
                  props.handleCardClick('courierDeliveringCount')
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`در حال تحویل   | ${props.counts[2]}`}
              </Button>

              <Button
                onClick={name =>
                  props.handleCardClick('courierNotDeliverdCount')
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`تحویل نشده  | ${props.counts[3]}`}
              </Button>
              <Button
                onClick={name => props.handleCardClick('courierReturnedCount')}
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`بازگردانده شده   | ${props.counts[4]}`}
              </Button>
            </Grid>
          )}
          {props.cardType === 'Post' && (
            <Grid md={12} item>
              <Button
                onClick={name =>
                  props.handleCardClick('courierDeliveringPostCount')
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`در حال تحویل به پست    | ${props.counts[0]}`}
              </Button>
              <Button
                onClick={name =>
                  props.handleCardClick('courierDeliveredPostCount')
                }
                variant="outlined"
                style={{margin: '4px'}}
              >
                {`ارسال به پست       | ${props.counts[1]}`}
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
      <CardActions
        style={{marginTop: 'auto', display: 'flex', flexDirection: 'column'}}
      >
        <Divider style={{width: '100%', marginBottom: '10px'}} />
        <Button
          style={{
            marginRight: 'auto',
            marginBottom: '8px',
            marginLeft: '8px',
          }}
          onClick={() => props.history.push(props.loginUrl)}
          variant="contained"
          color="secondary"
        >
          مشاهده
          <Icon path={mdiChevronLeft} size={1} />
        </Button>
      </CardActions>
    </Card>
  );
};

export default CourierCards;
